import { MENU_ITEMS } from '../constants/common';

export const getIndexDropdownMenuItemsConfig = () => {
  return {
    authorized: {
      desktop: [
        MENU_ITEMS.profile,
        MENU_ITEMS.virtualcard,
        MENU_ITEMS.achievements,
        // TODO remove comment when needed
        // MENU_ITEMS.travelexpert,
        MENU_ITEMS.exit,
      ],
      mobile: [
        MENU_ITEMS.profile,
        MENU_ITEMS.virtualcard,
        MENU_ITEMS.achievements,
        // TODO remove comment when needed
        // MENU_ITEMS.travelexpert,
        MENU_ITEMS.exit,
      ],
    },
    notAuthorized: {
      desktop: [],
      mobile: [MENU_ITEMS.order, MENU_ITEMS.mobileLogin],
    },
  };
};

export const getIndexMenuItemsConfig = () => {
  return {
    authorized: [MENU_ITEMS.profile],
    notAuthorized: {
      desktop: [MENU_ITEMS.profileLogin],
      mobile: [],
    },
  };
};

export const getProductsDropdownMenuItemsConfig = () => {
  return {
    authorized: [
      MENU_ITEMS.profile,
      MENU_ITEMS.virtualcard,
      MENU_ITEMS.achievements,
      // TODO remove comment when needed
      // MENU_ITEMS.travelexpert,
      MENU_ITEMS.exit,
    ],
    notAuthorized: {
      desktop: [],
      mobile: [MENU_ITEMS.order, MENU_ITEMS.mobileLogin],
    },
  };
};

export const getProductsMenuItemsConfig = () => {
  return {
    authorized: [MENU_ITEMS.profile],
    notAuthorized: {
      desktop: [MENU_ITEMS.order, MENU_ITEMS.login],
      mobile: [],
    },
  };
};
